import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { scrollToSection } from "@/lib/scroll";

const COLS = [
  {
    title: "Services",
    links: [
      { label: "Full-Service Vending", id: "services" },
      { label: "Micro Markets", id: "services" },
      { label: "Coffee & Pantry", id: "services" },
      { label: "Smart Coolers", id: "services" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "The Machines", id: "machines" },
      { label: "How It Works", id: "how-it-works" },
      { label: "Get a Quote", id: "quote" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer-container" className="relative overflow-hidden border-t border-black/10 pt-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <LogoMark />
              <span className="leading-none">
                <span className="block font-display text-lg font-extrabold tracking-tight text-[#16120E]">
                  SnackSavvy
                </span>
                <span className="mt-0.5 block font-mono text-[9px] uppercase tracking-[0.32em] text-[#A8861D]">
                  Vending Services
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-stone-500">
              Full-line vending operator for modern workplaces. Smart machines, micro
              markets and café-grade coffee — installed free, managed 24/7.
            </p>
            <div className="mt-6 space-y-1.5 font-mono text-sm">
              <a
                data-testid="footer-support-phone"
                href="tel:+12042186681"
                className="block text-stone-600 transition-colors hover:text-[#1B365D]"
              >
                204-218-6681
              </a>
              <a
                data-testid="footer-support-email"
                href="mailto:info@snacksavvyvending.ca"
                className="block text-stone-600 transition-colors hover:text-[#1B365D]"
              >
                info@snacksavvyvending.ca
              </a>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-mono text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500">
                {col.title}
              </h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <button
                      onClick={() => scrollToSection(l.id)}
                      className="group inline-flex items-center gap-1 text-sm text-stone-600 transition-colors hover:text-[#1B365D]"
                    >
                      {l.label}
                      <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-mono text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-500">
              Hours
            </h4>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li className="flex justify-between gap-6">
                <span className="text-slate-500">Machines</span>
                <span className="font-mono text-[#1B365D]">24 / 7</span>
              </li>
              <li className="flex justify-between gap-6">
                <span className="text-slate-500">Support line</span>
                <span className="font-mono text-[#1B365D]">24 / 7</span>
              </li>
              <li className="flex justify-between gap-6">
                <span className="text-slate-500">Restocking</span>
                <span className="font-mono text-[#A8861D]">Telemetry-driven</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="select-none px-2" aria-hidden="true">
        <p className="bg-gradient-to-b from-black/10 to-transparent bg-clip-text text-center font-display text-[clamp(3.2rem,13.5vw,12rem)] font-black leading-[0.85] tracking-tight text-transparent">
          SNACKSAVVY
        </p>
      </div>

      <div className="border-t border-black/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-slate-500 sm:flex-row sm:px-8">
          <p>© {new Date().getFullYear()} SnackSavvy Vending Services. All rights reserved.</p>
          <p className="font-mono uppercase tracking-[0.18em]">Made for workplaces that snack smart</p>
        </div>
      </div>
    </footer>
  );
}
